import React, { useState, useRef, useEffect} from 'react';
import { TabList, TabPanel, Tabs, Tab } from 'react-tabs';
import { Channel_CODE_SET } from '../../../../config/CgmCodeSet';
import ExportExcel from '../../../container/export-excel/ExportExcel';
import ColumnForReport from '../../graph/bar/ColumnForReport';
import MapForReport from '../../graph/force-directed-tree/MapForReport';
import LineForReport from '../../graph/line/LineForReport';
import PieForReport from '../../graph/pie/PieForReport';
import WordCloud from '../../graph/wordcloud/WordCloud';
import TableForReport from '../../table/TableForReport';
import arrowImg from '../../../../img/icon_arrow2.gif'

import './SnapshotManagerResult.css';

const arrayCompare = (arr1, arr2) => {
  for(let i=0; i<arr1.length || i<arr2.length; i++){
    if(arr1[i] !== arr2[i]){
      return false;
    }
    else{
      continue;
    }
  }
  return true;
}

// const ReportMap = (props) => {
//   switch(props.reportType) {
//     case "category": {
//       return (
//         <Tabs style={{margin: "10px"}}>
//           <TabList style={{display: "-webkit-box"}}>
//             {props.data.map(item=>{
//               return (
//                 <Tab>{`${item.query.join(' & ')} (${Channel_CODE_SET[item.channel]})`}</Tab>
//               )
//             })}
//           </TabList>
//           {props.data.map(item=>{
//             return(
//               <TabPanel>
//                 <MapForReport width="100%" height={500} data={item.data} excelExportFunc={props.excelExportFunc}/>
//               </TabPanel>
//             )
//           })}
//         </Tabs>
//       )
//     }
//     case "relation": {
//       return(
//         <Tabs style={{margin: "10px"}}>
//           <TabList style={{display: "-webkit-box"}}>
//             {props.data.map(item=>{
//               return(
//                 <Tab>{`${item.query.join(' & ')} (${Channel_CODE_SET[item.channel]})`}</Tab>
//               )
//             })}
//           </TabList>
//           {props.data.map(item=>{
//             return(
//               <TabPanel>
//                 <WordCloud data={item.data} height={800} width={800}
//                   // maxWords={}
//                 />
//               </TabPanel>
//             )
//           })}
//         </Tabs>
//       )
//     }
//     default:
//       return null;
//       break;
//   }
// }

// const ReportTable = (props) => {
//   switch(props.reportType){
//     case "volume": {
//       return(
//         <TableForReport pageSize={10} reportType={props.data.reportType} data={props.data} />
//       )
//       break;
//     }
//     case "sentiment": {
//       let queryList = [];

//       props.data.reportData.forEach(item=>{
//         if (queryList.length == 0) {
//           queryList.push(item.query);
//         }
//         else {
//           queryList.some((query, index)=>{
//             if(arrayCompare(item.query, query)){
//               return true;
//             }
//             else {
//               if(index == (queryList.length-1)){
//                 queryList.push(item.query)
//               }
//             }
//           })
//         }
//       })
//       return (
//         <Tabs style={{margin: "10px"}}>
//           <TabList style={{display: "-webkit-box"}}>
//             {queryList.map(item=>{
//               return(
//                 <Tab>{item.join(' & ')}</Tab>
//               )
//             })}
//           </TabList>
//           {queryList.map(item=>{
//             return(
//               <TabPanel>
//                 <TableForReport pageSize={10} query={item} reportType={props.data.reportType} data={props.data} />
//               </TabPanel>
//             )
//           })}
//         </Tabs>
//       )
//       break;
//     }
//     case "source": {
//       return (
//         <Tabs style={{margin: "10px"}} >
//           <TabList style={{display: "-webkit-box"}}>
//             {props.data.reportData.map(reportItem=>{
//               return (
//                 <Tab>{`${reportItem.info.query.join(' & ')} (${Channel_CODE_SET[reportItem.info.channel]})`}</Tab>
//               )
//             })}
//           </TabList>
//           {props.data.reportData.map(reportItem=>{
//             return (
//               <TabPanel>
//                 <TableForReport pageSize={5} reportType={props.data.reportType} data={reportItem} />
//               </TabPanel>
//             )
//           })}
//         </Tabs>
//       )
//       break;
//     }
//     case "category": {
//       return (
//         <Tabs style={{margin: "10px"}} >
//           <TabList style={{display: "-webkit-box"}}>
//             {props.data.reportData.map(reportItem=>{
//               return (
//                 <Tab>{`${reportItem.query.join(' & ')} (${Channel_CODE_SET[reportItem.channel]})`}</Tab>
//               )
//             })}
//           </TabList>
//           {props.data.reportData.map(reportItem=>{
//             return (
//               <TabPanel>
//                 <TableForReport pageSize={10} reportType={props.data.reportType} data={reportItem} />
//               </TabPanel>
//             )
//           })}
//         </Tabs>
//       )
//     }
//     default:
//       return null;
//       break;
//   }
// }

// const ReportLine = (props) => {
//   return(
//     <Tabs style={{margin: "10px"}}>
//       <TabList style={{display: "-webkit-box"}}>
//         {props.data.map((item, index)=>{
//           let tabName = item.query.join(' & ');
//           if(props.reportType == 'sentiment'){
//             tabName = `${tabName}(${Channel_CODE_SET[item.channel]})`
//           }
//           return (
//             <Tab>{tabName}</Tab>
//           )
//         })}
//       </TabList>
//       {props.data.map((item, index)=>(
//         <TabPanel>
//           <LineForReport reportType={props.reportType} width="100%" height={500} data={item} timeunit={props.timeunit} datatype={props.datatype} excelExportFunc={props.excelExportFunc}/>
//         </TabPanel>
//       ))}
//     </Tabs>
//   )
// }

// const ReportColumn = (props) => {
  
//   return(
//     <Tabs style={{margin: "10px"}}>
//       <TabList style={{display: "-webkit-box"}}>
//       {props.data.map((item, index)=>{
//           let tabName = item.query.join(' & ');
//           if(props.reportType == 'sentiment'){
//             tabName = `${tabName}(${Channel_CODE_SET[item.channel]})`
//           }
//           return (
//             <Tab>{tabName}</Tab>
//           )
//         })}
//       </TabList>  
//       {props.data.map((item, index)=>(
//         <TabPanel>
//           <ColumnForReport reportType={props.reportType} width="100%" height={500} data={item} timeunit={props.timeunit} datatype={props.datatype} excelExportFunc={props.excelExportFunc}/>
//         </TabPanel>
//       ))}
//     </Tabs>
//   )
// }

// const ReportPie = (props) => {
//   return(
//     <Tabs style={{margin: "10px"}}>
//       <TabList style={{display: "-webkit-box"}}>
//       {props.data.map((item, index)=>{
//           let tabName = item.query.join(' & ');
//           if(props.reportType == 'sentiment'){
//             tabName = `${tabName}(${Channel_CODE_SET[item.channel]})`
//           }
//           return (
//             <Tab>{tabName}</Tab>
//           )
//         })}
//       </TabList>
//       {props.data.map((item, index)=>(
//         <TabPanel>
//           <PieForReport reportType={props.reportType} width="100%" height={500} data={item} excelExportFunc={props.excelExportFunc}/>
//         </TabPanel>
//       ))}
//     </Tabs>
//   )
// }

// const ReportResult = (props) => {
//   switch(props.data.reportType) {
//     case "volume": {
//       return(
//         <div className="snapshot-graph">
//           <Tabs>
//             <TabList>
//               <Tab>Line</Tab><Tab>Column</Tab><Tab>Pie</Tab><Tab>Table</Tab>
//             </TabList>
//             <TabPanel>
//               <ReportLine reportType={props.data.reportType} data={props.data.reportData} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc}/>
//             </TabPanel>
//             <TabPanel>
//               <ReportColumn reportType={props.data.reportType} data={props.data.reportData} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc}/>
//             </TabPanel>
//             <TabPanel>
//               <ReportPie reportType={props.data.reportType} data={props.data.reportData} excelExportFunc={props.excelExportFunc} />
//             </TabPanel>
//             <TabPanel>
//               <ReportTable reportType={props.data.reportType} data={props.data} />
//             </TabPanel>
//           </Tabs>
//         </div>
//       )
//       break;
//     }
//     case "sentiment": {
//       return(
//         <div className="snapshot-graph">
//           <Tabs>
//             <TabList>
//               <Tab>Line</Tab><Tab>Column</Tab><Tab>Pie</Tab><Tab>Table</Tab>
//             </TabList>
//             <TabPanel>
//               <ReportLine reportType={props.data.reportType} data={props.data.reportData} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc}/>
//             </TabPanel>
//             <TabPanel>
//               <ReportColumn reportType={props.data.reportType} data={props.data.reportData} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc}/>
//             </TabPanel>
//             <TabPanel>
//               <ReportPie reportType={props.data.reportType} data={props.data.reportData} excelExportFunc={props.excelExportFunc} />
//             </TabPanel>
//             <TabPanel>
//               <ReportTable reportType={props.data.reportType} data={props.data} />
//             </TabPanel>
//           </Tabs>
//         </div>
//       )
//       break;
//     }
//     case "source": {
//       return(
//         <div className="snapshot-graph">
//           <Tabs>
//             <TabList>
//               <Tab>Table</Tab>
//             </TabList>
//             <TabPanel>
//               <ReportTable reportType={props.data.reportType} data={props.data} />
//             </TabPanel>
//           </Tabs>
//         </div>
//       )
//       break;
//     }
//     case "category": {
//       return(
//         <div className="snapshot-graph">
//           <Tabs>
//             <TabList>
//               <Tab>map</Tab><Tab>Table</Tab>
//             </TabList>
//             <TabPanel>
//               <ReportMap reportType={props.data.reportType} data={props.data.reportData} excelExportFunc={props.excelExportFunc} />
//             </TabPanel>
//             <TabPanel>
//               <ReportTable reportType={props.data.reportType} data={props.data} />
//             </TabPanel>
//           </Tabs>
//         </div>
//       )
//       break;
//     }
//     case "relation": {
//       return(
//         <div className="snapshot-graph">
//           <Tabs>
//             <TabList>
//               <Tab>Map</Tab>
//             </TabList>
//             <TabPanel>
//               <ReportMap reportType={props.data.reportType} data={props.data.reportData} />
//             </TabPanel>
//           </Tabs>
//         </div>
//       )
//       break;
//     }
//     case "positioningmap": {
//       return(
//         <div className="snapshot-graph">
//         </div>
//       )
//       break;
//     }
//     default:
//       break;
//   }
// }


const ReportMap = (props) => {
  switch(props.data.reportType) {
    case "category": {
      return (
        <Tabs style={{margin: "10px"}}>
          <TabList style={{display: "-webkit-box"}}>
            {props.data.reportData.map(item=>{
              return (
                <Tab>{`${item.query.join(' & ')} (${Channel_CODE_SET[item.channel]})`}</Tab>
              )
            })}
          </TabList>
          {props.data.reportData.map(item=>{
            return(
              <TabPanel>
                <MapForReport type="snapshot" reportName={props.data.name} width="100%" height={500} data={item.data} excelExportFunc={props.excelExportFunc}/>
              </TabPanel>
            )
          })}
        </Tabs>
      )
    }
    case "relation": {
      return(
        <Tabs style={{margin: "10px"}}>
          <TabList style={{display: "-webkit-box"}}>
            {props.data.reportData.map(item=>{
              return(
                <Tab>{`${item.query.join(' & ')} (${Channel_CODE_SET[item.channel]})`}</Tab>
              )
            })}
          </TabList>
          {props.data.reportData.map(item=>{
            return(
              <TabPanel>
                <Tabs style={{margin: "10px"}}>
                  <TabList style={{display:"-webkit-box"}}>
                    {item.data.map(wordItem=>{
                      return(
                        <Tab>{wordItem.date}</Tab>
                      )
                    })}
                  </TabList>
                  {item.data.map(wordItem=>{
                    return(
                      <TabPanel>
                        <div className="WordCloudContainer">
                          <div className="WordCloudTitle">
                            <span>{`# ${props.data.name}-${item.query.join(' & ')} (${Channel_CODE_SET[item.channel]}) [${wordItem.date}]`}</span>
                            <div className="excel-btn-container">
                              <a className="button purple_line" style={{margin: "0px 10px 10px 0px"}} onClick={()=>props.excelExportFunc()}>Excel</a>
                            </div>
                          </div>
                          <WordCloud reportName={props.data.name} query={item.query} channel={item.channel} date={wordItem.date} data={wordItem.data} height={370} width={370} maxWords={100}/>
                        </div>
                      </TabPanel>
                    )
                  })}
                </Tabs>
                {/* {item.data.map(wordItem=>{
                  return(
                    <div className="WordCloudContainer">
                      <div className="WordCloudTitle">
                        <span>{`# ${props.data.name}-${item.query.join(' & ')} (${Channel_CODE_SET[item.channel]}) ${wordItem.date}`}</span>
                        <div className="excel-btn-container">
                          <a className="button grayS" style={{margin: "0px 10px 0px 0px"}} onClick={()=>props.excelExportFunc()}>Excel</a>
                        </div>
                      </div>
                      <WordCloud reportName={props.data.name} query={item.query} channel={item.channel} date={wordItem.date} data={wordItem.data} height={800} width={800}/>
                    </div>
                  )
                })} */}
              </TabPanel>
            )
            // return(
            //   <TabPanel>
            //     <WordCloud reportName={props.data.name} data={item.data} height={800} width={800}
            //     />
            //   </TabPanel>
            // )
          })}
        </Tabs>
      )
    }
    default:
      return null;
      break;
  }
}

const ReportTable = (props) => {
  switch(props.data.reportType){
    case "volume": {
      return(
        <TableForReport pageSize={10} reportType={props.data.reportType} data={props.data} />
      )
      break;
    }
    case "sentiment": {
      let queryList = [];

      props.data.reportData.forEach(item=>{
        if (queryList.length == 0) {
          queryList.push(item.query);
        }
        else {
          queryList.some((query, index)=>{
            if(arrayCompare(item.query, query)){
              return true;
            }
            else {
              if(index == (queryList.length-1)){
                queryList.push(item.query)
              }
            }
          })
        }
      })
      return (
        <Tabs style={{margin: "10px"}}>
          <TabList style={{display: "-webkit-box"}}>
            {queryList.map(item=>{
              return(
                <Tab>{item.join(' & ')}</Tab>
              )
            })}
          </TabList>
          {queryList.map(item=>{
            return(
              <TabPanel>
                <TableForReport pageSize={10} query={item} reportType={props.data.reportType} data={props.data} />
              </TabPanel>
            )
          })}
        </Tabs>
      )
      break;
    }
    case "source": {
      return (
        <Tabs style={{margin: "10px"}} >
          <TabList style={{display: "-webkit-box"}}>
            {props.data.reportData.map(reportItem=>{
              return (
                <Tab>{`${reportItem.info.query.join(' & ')} (${Channel_CODE_SET[reportItem.info.channel]})`}</Tab>
              )
            })}
          </TabList>
          {props.data.reportData.map(reportItem=>{
            return (
              <TabPanel>
                <TableForReport pageSize={5} reportType={props.data.reportType} data={reportItem} />
              </TabPanel>
            )
          })}
        </Tabs>
      )
      break;
    }
    case "category": {
      return (
        <Tabs style={{margin: "10px"}} >
          <TabList style={{display: "-webkit-box"}}>
            {props.data.reportData.map(reportItem=>{
              return (
                <Tab>{`${reportItem.query.join(' & ')} (${Channel_CODE_SET[reportItem.channel]})`}</Tab>
              )
            })}
          </TabList>
          {props.data.reportData.map(reportItem=>{
            return (
              <TabPanel>
                <TableForReport pageSize={10} reportType={props.data.reportType} data={reportItem} />
              </TabPanel>
            )
          })}
        </Tabs>
      )
    }
    default:
      return null;
      break;
  }
}

const ReportLine = (props) => {
  return(
    <Tabs style={{margin: "10px"}}>
      <TabList style={{display: "-webkit-box"}}>
        {props.data.reportData.map((item, index)=>{
          let tabName = item.query.join(' & ');
          if(props.data.reportType == 'sentiment'){
            tabName = `${tabName}(${Channel_CODE_SET[item.channel]})`
          }
          return (
            <Tab>{tabName}</Tab>
          )
        })}
      </TabList>
      {props.data.reportData.map((item, index)=>(
        <TabPanel>
          <LineForReport reportName={props.data.name} reportType={props.data.reportType} width="100%" height={500} data={item} timeunit={props.timeunit} datatype={props.datatype} excelExportFunc={props.excelExportFunc}
            mainQuery={props.data.mainQuery} subQuery={props.data.subQuery} subQueryType={props.data.subQueryType} reTweet={props.data.reTweet} channels={props.data.channels} userRole={props.userRole}
          />
        </TabPanel>
      ))}
    </Tabs>
  )
}

const ReportColumn = (props) => {
  
  return(
    <Tabs style={{margin: "10px"}}>
      <TabList style={{display: "-webkit-box"}}>
      {props.data.reportData.map((item, index)=>{
          let tabName = item.query.join(' & ');
          if(props.data.reportType == 'sentiment'){
            tabName = `${tabName}(${Channel_CODE_SET[item.channel]})`
          }
          return (
            <Tab>{tabName}</Tab>
          )
        })}
      </TabList>  
      {props.data.reportData.map((item, index)=>(
        <TabPanel>
          <ColumnForReport reportName={props.data.name} reportType={props.data.reportType} width="100%" height={500} data={item} timeunit={props.timeunit} datatype={props.datatype} excelExportFunc={props.excelExportFunc}
          mainQuery={props.data.mainQuery} subQuery={props.data.subQuery} subQueryType={props.data.subQueryType} reTweet={props.data.reTweet} channels={props.data.channels} userRole={props.userRole}
          />
        </TabPanel>
      ))}
    </Tabs>
  )
}

const ReportPie = (props) => {
  return(
    <Tabs style={{margin: "10px"}}>
      <TabList style={{display: "-webkit-box"}}>
      {props.data.reportData.map((item, index)=>{
          let tabName = item.query.join(' & ');
          if(props.data.reportType == 'sentiment'){
            tabName = `${tabName}(${Channel_CODE_SET[item.channel]})`
          }
          return (
            <Tab>{tabName}</Tab>
          )
        })}
      </TabList>
      {props.data.reportData.map((item, index)=>(
        <TabPanel>
          <PieForReport reportName={props.data.name} reportType={props.data.reportType} width="100%" height={500} data={item} excelExportFunc={props.excelExportFunc}
          mainQuery={props.data.mainQuery} subQuery={props.data.subQuery} subQueryType={props.data.subQueryType} reTweet={props.data.reTweet} channels={props.data.channels} userRole={props.userRole}
          type="snapshot"
          />
        </TabPanel>
      ))}
    </Tabs>
  )
}

const ReportResult = (props) => {
  switch(props.data.reportType) {
    case "volume": {
      return(
        <div className="snapshot-graph">
          <Tabs>
            <TabList>
              <Tab>Line</Tab><Tab>Column</Tab><Tab>Pie</Tab><Tab>Table</Tab>
            </TabList>
            <TabPanel>
              {/* <ReportLine reportType={props.data.reportType} data={props.data.reportData} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc}/> */}
              <ReportLine data={props.data} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc} userRole={props.userRole}/>
            </TabPanel>
            <TabPanel>
              <ReportColumn data={props.data} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc} userRole={props.userRole}/>
            </TabPanel>
            <TabPanel>
              <ReportPie data={props.data} excelExportFunc={props.excelExportFunc} userRole={props.userRole}/>
            </TabPanel>
            <TabPanel>
              <ReportTable data={props.data} excelExportFunc={props.excelExportFunc} />
            </TabPanel>
          </Tabs>
        </div>
      )
      break;
    }
    case "sentiment": {
      return(
        <div className="snapshot-graph">
          <Tabs>
            <TabList>
              <Tab>Line</Tab><Tab>Column</Tab><Tab>Pie</Tab><Tab>Table</Tab>
            </TabList>
            <TabPanel>
              <ReportLine data={props.data} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc} userRole={props.userRole}/>
            </TabPanel>
            <TabPanel>
              <ReportColumn data={props.data} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc} userRole={props.userRole} />
            </TabPanel>
            <TabPanel>
              <ReportPie data={props.data} excelExportFunc={props.excelExportFunc} userRole={props.userRole}/>
            </TabPanel>
            <TabPanel>
              <ReportTable data={props.data} excelExportFunc={props.excelExportFunc} />
            </TabPanel>
          </Tabs>
        </div>
      )
      break;
    }
    case "source": {
      return(
        <div className="snapshot-graph">
          <Tabs>
            <TabList>
              <Tab>Table</Tab>
            </TabList>
            <TabPanel>
              <ReportTable data={props.data} excelExportFunc={props.excelExportFunc} />
            </TabPanel>
          </Tabs>
        </div>
      )
      break;
    }
    case "category": {
      return(
        <div className="snapshot-graph">
          <Tabs>
            <TabList>
              <Tab>Map</Tab><Tab>Table</Tab>
            </TabList>
            <TabPanel>
              <ReportMap data={props.data} excelExportFunc={props.excelExportFunc} />
            </TabPanel>
            <TabPanel>
              <ReportTable data={props.data} excelExportFunc={props.excelExportFunc} />
            </TabPanel>
          </Tabs>
        </div>
      )
      break;
    }
    case "relation": {
      return(
        <div className="snapshot-graph">
          <Tabs>
            <TabList>
              <Tab>Map</Tab>
            </TabList>
            <TabPanel>
              <ReportMap data={props.data} excelExportFunc={props.excelExportFunc} />
            </TabPanel>
          </Tabs>
        </div>
      )
      break;
    }
    case "positioningmap": {
      return(
        <div className="snapshot-graph">
        </div>
      )
      break;
    }
    default:
      break;
  }
}

const SnapshotManagerResult = (props) => {
  const [tooltipShow, setTooltipShow] = useState(false);
  const tooltipTarget = useRef(null);
  useEffect(() => {
    const timerId = setInterval(() => {
      if(tooltipShow) setTooltipShow(false);
    }, 3000);
    return ()=>clearInterval(timerId);
  }, [tooltipShow])

  return (
    <>
      {React.useMemo(()=>{
        return (
        <div className="snapshot-manager-result-box-container">
        {props.volumeResult ?
        <div className="snapshot-manager-result-box">
        <div className="optionSettingTit"><img src={arrowImg} align="absmiddle" /> 버즈량</div><br/>
        <ReportResult data={props.volumeResult} timeunit={props.options.timeunit} datatype={props.options.datatype} excelExportFunc={()=>ExportExcel('report-graph', props.volumeResult)} userRole={props.userRole}/></div> :undefined}
        {props.sentimentResult ?
        <div className="snapshot-manager-result-box">
        <div className="optionSettingTit"><img src={arrowImg} align="absmiddle" /> 감성 분석</div><br/>
        <ReportResult data={props.sentimentResult} timeunit={props.options.timeunit} datatype={props.options.datatype} excelExportFunc={()=>ExportExcel('report-graph', props.sentimentResult)} userRole={props.userRole}/></div> :undefined}
        {props.sourceResult ?
        <div className="snapshot-manager-result-box">
        <div className="optionSettingTit"><img src={arrowImg} align="absmiddle" /> 영향 채널</div><br/>
        <ReportResult data={props.sourceResult} timeunit={props.options.timeunit} datatype={props.options.datatype} excelExportFunc={()=>ExportExcel('report-graph', props.sourceResult)} userRole={props.userRole}/></div> :undefined}
        {props.categoryResult ?
        <div className="snapshot-manager-result-box">
        <div className="optionSettingTit"><img src={arrowImg} align="absmiddle" /> 카테고리 분석</div><br/>
        <ReportResult data={props.categoryResult} timeunit={props.options.timeunit} datatype={props.options.datatype} excelExportFunc={()=>ExportExcel('report-graph', props.relationResult)} userRole={props.userRole}/></div> :undefined}
      </div>
        )
      }, [props.volumeResult, props.sentimentResult, props.sourceResult, props.categoryResult])}
    </>

  )
}

export default SnapshotManagerResult;